export default __webpack_public_path__ + "static/Entenda0043-211a652d9460b2a1dc4c3ef22a7f0a37.jpg";